import loadMoreConversationsFromServer from './helpers/loadMoreConversationsFromServer';
import loadMoreItemsFromServer from './helpers/loadMoreItemsFromServer';
import { LOAD_MORE_ROW_COUNT } from '../data-loading/TableLoadingConstants';
import { TableQueryType } from 'owa-mail-list-store';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { action } from 'satcheljs/lib/legacy';
import { SearchTableQuery } from 'owa-mail-list-search';
import { onLoadMoreRowsFailed, onLoadMoreRowsSucceeded } from './onLoadMoreRowsCompleted';
import { lazyLoadMoreFindItemSearch } from 'owa-mail-execute-search-actions';
import { SearchScopeKind } from 'owa-search-service';

/**
 * Load more rows from server to the given table
 * @param tableView to be loaded
 */
function loadMoreRowsFromServer(tableView: TableView) {
    tableView.isLoading = true;

    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            loadMoreConversationsFromServer(tableView);
            break;

        case ReactListViewType.Message:
            loadMoreItemsFromServer(tableView);
            break;
    }
}

/**
 * Load more data in table
 * @param tableView to be loaded
 */
export default action('loadMoreInTable')(async function loadMoreInTable(tableView: TableView) {
    if (!tableView) {
        throw new Error('Selected tableview must not be null if loadMoreRows is being called.');
    }

    const rowsToLoad = LOAD_MORE_ROW_COUNT;

    if (tableView.currentLoadedIndex < tableView.rowKeys.length) {
        // We have items locally not yet rendered. Let's try to increase loaded range those before going to the server
        const localItemsLeft = tableView.rowKeys.length - tableView.currentLoadedIndex;
        if (localItemsLeft >= rowsToLoad) {
            // We have enough to satisfy current range, so render that. No need to go to the server
            tableView.currentLoadedIndex += rowsToLoad;
            return;
        }

        // We have more items locally, but not enough to satisfy current range.
        // Render what we have and also go to the server
        tableView.currentLoadedIndex = tableView.rowKeys.length;
    }

    // Load more calls for the server are only supported for Folder table types and for Shared folder Search table type
    if (
        tableView.tableQuery.type == TableQueryType.Folder ||
        tableView.tableQuery.type == TableQueryType.Group
    ) {
        loadMoreRowsFromServer(tableView);
    } else if (tableView.tableQuery.type === TableQueryType.Search) {
        const tableQuery = tableView.tableQuery as SearchTableQuery;
        if (tableQuery.searchScope.kind === SearchScopeKind.SharedFolders) {
            const loadMoreFindItemSearchAction = await lazyLoadMoreFindItemSearch.import();
            loadMoreFindItemSearchAction(
                tableView.currentLoadedIndex - 1 /* offset */,
                tableView,
                'loadMoreInTable' /* actionSource */,
                onLoadMoreRowsSucceeded,
                onLoadMoreRowsFailed
            );
        }
    }
});
